var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileCircle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#E9FBF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 7C10.8026 7 10.2939 7.21071 9.91879 7.58579C9.54372 7.96086 9.33301 8.46957 9.33301 9V25C9.33301 25.5304 9.54372 26.0391 9.91879 26.4142C10.2939 26.7893 10.8026 27 11.333 27H23.333C23.8634 27 24.3721 26.7893 24.7472 26.4142C25.1223 26.0391 25.333 25.5304 25.333 25V13L19.333 7H11.333ZM11.333 9H18.333V14H23.333V25H11.333V9ZM13.333 17V19H21.333V17H13.333ZM13.333 21V23H18.333V21H13.333Z",
    fill: "#00777E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileCircle3);
export default __webpack_public_path__ + "static/media/icon-file-circle-3.edb204cc8f240ce9790ea5d6ee106360.svg";
export { ForwardRef as ReactComponent };